import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { APP_NAME } from "@/config";

const checklistItems = [
    "Final completion report details in the Project Central",
    "Saved all final deliverables to the Project folder",
    "Ensured all invoices & receipts are saved in the Project Finances folder",
    `Obtained a P&L from Finance, if any numbers in ${APP_NAME} were off`,
    `Added milestone reminders in ${APP_NAME} to flag usage tracking/expiry`,
    "Actualized the bid sheet",
];

export default function WrapDialog(props) {
    const { open, handleClose } = props;

    return (
        <Dialog open={open} onClose={() => handleClose(false)}>
            <DialogTitle>Let&apos;s Wrap This Up</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    By clicking submit you are confirming that you have
                    completed the following steps:
                </DialogContentText>

                <List dense sx={{ marginTop: "12px" }}>
                    {checklistItems.map((item, index) => (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <CheckCircleIcon color="success" />
                            </ListItemIcon>
                            <ListItemText primary={item} />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={() => handleClose(false)}>
                    Cancel
                </Button>
                <Button color="success" onClick={() => handleClose(true)}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}
